import apiClient from "../helpers/ApiClient";

// ── Dashboard & Occupancy ──
export const getGymDashboardStats = async () => {
  const res = await apiClient.get("/gym/dashboard-stats");
  return res.data;
};

export const getLiveOccupancy = async () => {
  const res = await apiClient.get("/gym/live-occupancy");
  return res.data;
};

export const adjustOccupancy = async (corrected_occupancy, reason) => {
  const res = await apiClient.post("/gym/live-occupancy/adjust", {
    corrected_occupancy,
    reason,
  });
  return res.data;
};

// ── Members & Import ──
export const getMembers = async (params = {}) => {
  const res = await apiClient.get("/gym/members", { params });
  return res.data;
};

export const getMemberById = async (id) => {
  const res = await apiClient.get(`/gym/members/${id}`);
  return res.data;
};

export const createMember = async (data) => {
  const res = await apiClient.post("/gym/members", data);
  return res.data;
};

export const updateMember = async (id, data) => {
  const res = await apiClient.put(`/gym/members/${id}`, data);
  return res.data;
};

export const deleteMember = async (id) => {
  const res = await apiClient.delete(`/gym/members/${id}`);
  return res.data;
};

export const bulkImportMembers = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiClient.post("/gym/members/bulk-import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const downloadImportTemplate = async (format = "csv") => {
  const res = await apiClient.get("/gym/members/template", {
    params: { format },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `gym_members_template.${format}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

// ── Membership Plans ──
export const getPlans = async (activeOnly = false) => {
  const res = await apiClient.get("/gym/plans", {
    params: { active_only: activeOnly },
  });
  return res.data;
};

export const createPlan = async (data) => {
  const res = await apiClient.post("/gym/plans", data);
  return res.data;
};

export const updatePlan = async (id, data) => {
  const res = await apiClient.put(`/gym/plans/${id}`, data);
  return res.data;
};

export const deletePlan = async (id) => {
  const res = await apiClient.delete(`/gym/plans/${id}`);
  return res.data;
};

// ── Subscriptions ──
export const getSubscriptions = async (params = {}) => {
  const res = await apiClient.get("/gym/subscriptions", { params });
  return res.data;
};

export const createSubscription = async (data) => {
  const res = await apiClient.post("/gym/subscriptions", data);
  return res.data;
};

export const freezeSubscription = async (id, data) => {
  const res = await apiClient.post(`/gym/subscriptions/${id}/freeze`, data);
  return res.data;
};

export const unfreezeSubscription = async (id) => {
  const res = await apiClient.post(`/gym/subscriptions/${id}/unfreeze`);
  return res.data;
};

export const cancelSubscription = async (id, reason) => {
  const res = await apiClient.post(`/gym/subscriptions/${id}/cancel`, { reason });
  return res.data;
};

// ── Devices & ADMS ──
export const getDevices = async () => {
  const res = await apiClient.get("/gym/devices");
  return res.data;
};

export const getDeviceById = async (id) => {
  const res = await apiClient.get(`/gym/devices/${id}`);
  return res.data;
};

export const createDevice = async (data) => {
  const res = await apiClient.post("/gym/devices", data);
  return res.data;
};

export const updateDevice = async (id, data) => {
  const res = await apiClient.put(`/gym/devices/${id}`, data);
  return res.data;
};

export const deleteDevice = async (id) => {
  const res = await apiClient.delete(`/gym/devices/${id}`);
  return res.data;
};

export const getDeviceCommands = async (id, status = null) => {
  const res = await apiClient.get(`/gym/devices/${id}/commands`, {
    params: status ? { status } : {},
  });
  return res.data;
};

export const queueDeviceCommand = async (id, command) => {
  const res = await apiClient.post(`/gym/devices/${id}/commands`, { command });
  return res.data;
};

export const remoteUnlockDoor = async (id, reason) => {
  const res = await apiClient.post(`/gym/devices/${id}/remote-unlock`, { reason });
  return res.data;
};

export const syncAllMembersToDevice = async (id) => {
  const res = await apiClient.post(`/gym/devices/${id}/sync-members`);
  return res.data;
};

// ── Access Logs & Reports ──
export const getAccessLogs = async (params = {}) => {
  const res = await apiClient.get("/gym/access-logs", { params });
  return res.data;
};

export const getRemoteUnlockLogs = async () => {
  const res = await apiClient.get("/gym/remote-unlock-logs");
  return res.data;
};
